import data from './data.js';

/**
 * Get a system message for a specific error code, replacing placeholders with provided parameters.
 *
 * @param {string} errorCode - The error code for which the system message is needed.
 * @param {string[]} params - An array of parameters to replace placeholders in the system message.
 * @returns {string} The system message with placeholders replaced by the provided parameters.
 */
function getSysMsg(errorCode, params) {
  let str = data[errorCode].sysMsg;

  // loop over the params and replace the template string with the parameter
  // eslint-disable-next-line array-callback-return
  params.map((param, i) => {
    str = str.replace(`params[${i}]`, param);
  });
  return str;
}
export default getSysMsg;